module.exports = __webpack_public_path__ + "static/media/BASEBALL.136b2dab.mp4";